var exports = {
  "wz": "dragItem__9gu_02",
  "Vd": "vertical__Qt3HHr",
  "xM": "horizontal__38i8y2",
  "PG": "contents__q0-MDK",
  "$1": "dragOverlay__WsPNF8",
};

module.exports = exports;
